
const genderOptions = [ 
    { _id: 'male', stringDisplayed: 'Male'},
    { _id: 'female', stringDisplayed: 'Female'}, 
    { _id: 'other', stringDisplayed: 'Other'}
]; 

export default genderOptions; 